export default __webpack_public_path__ + "static/media/kh.e985d18c.svg";